module.exports = __webpack_public_path__ + "img/tp4800.9aeca599.png";